import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PolicyException } from '../../../../../types';
import { PolicyExceptionsFormStepContextProvider } from '../../../../../contexts';
import { useEditPolicyExceptionDialogForm } from '../../../../forms';
import { useDeletePolicyExceptionConfirmationDialog } from '../../../../forms/hooks/useDeletePolicyExceptionConfirmationDialog';

interface PolicyExceptionsTableRowActionProps {
    policyException: PolicyException;
}

export const PolicyExceptionsTableRowAction = ({ policyException }: PolicyExceptionsTableRowActionProps) => {
    const [renderEditDialog, toggleEditDialog] = useEditPolicyExceptionDialogForm({ policyException });
    const { confirmationDialog, openConfirmationDialog } = useDeletePolicyExceptionConfirmationDialog({
        policyExceptionId: policyException.policyId,
    });
    return (
        <PolicyExceptionsFormStepContextProvider>
            <DropDownButton icon={IconName.More} variant="ghost" size="small">
                <DropdownItem label={lt('Edit')} onClick={toggleEditDialog} />
                {policyException.policyId ? (
                    <DropdownItem label={lt('Delete')} variant="danger" onClick={openConfirmationDialog} />
                ) : null}
            </DropDownButton>
            {renderEditDialog()}
            {confirmationDialog}
        </PolicyExceptionsFormStepContextProvider>
    );
};
